var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isShow
        ? _c(
            "div",
            {
              staticClass: "dimline0",
              class: { bgray: _vm.isGray, pl16: !_vm.isGray },
            },
            [
              _c("div", { ref: "dimline", staticClass: "dimline1" }, [
                _c("p"),
                _c("div", { staticClass: "dim-andor" }, [
                  _c(
                    "div",
                    {
                      class: { active: _vm.anded === 1 },
                      on: {
                        click: function ($event) {
                          return _vm.andedFn(1)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("pc_spmodel_the_and")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      class: { active: _vm.anded === 2 },
                      on: {
                        click: function ($event) {
                          return _vm.andedFn(2)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("pc_spmodel_the_or")) +
                          "\n        "
                      ),
                    ]
                  ),
                ]),
              ]),
              _c(
                "div",
                { ref: "dimlines", staticClass: "dimline2" },
                [_vm._t("default")],
                2
              ),
            ]
          )
        : _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }